export const PROFILE_ROUTES = {
  ROOT: '/profile',
}
